import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import AOS from "aos";

import "./Aircraft.scss";
import AircraftStat from "./../../components/AircraftStat";
import m16 from "./../../img/aircraft/m16.jpg";

export default function AircraftHiLift() {
  useEffect(() => {
    AOS.init({
      easing: "ease",
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>Hi-Lift Aircraft | M-Fly</title>
      </Helmet>
      <div className="Aircraft">
        <div className="white-div">
          <div className="clearfix aircraft-container">
            <img
              src={m16}
              alt="M-16"
              className="float-left"
              data-aos="fade-right"
              data-aos-easing="ease"
              data-aos-duration="2000"
            />
            <div className="info">
              <h1 className="aircraft-name">M-16</h1>
              <p className="aircraft-description">
                The M-16 is a high lift aircraft for the 2023 SAE Aero Design East
                Competition. The aircraft carries a payload of 20 pounds loaded
                along the length of the fuselage. The aircraft is almost
                exclusively built from wood and utilizes a carbon fiber
                propeller and landing gear. After our competition, the M-16
                placed 12th out of 32 teams overall in the 2024 SAE Aero Design
                East Competition, winning an award for the best design in the US
                (2nd overall).
              </p>
            </div>
          </div>
          <div className="stats">
            <AircraftStat value="19 lbs" label="empty weight" />
            <AircraftStat value="40 lbs" label="max takeoff weight" />
            <AircraftStat value="15 ft" label="wingspan" />
            <AircraftStat value="35.4 ft/s" label="max flight speed" />
          </div>
        </div>
      </div>
    </>
  );
}
